<template>
  <div class="search-tabs mt-2">
    <ul class="-mb-px flex space-x-6">
      <li v-for="(tab, tabKey) in tabs" :key="tabKey">
        <c-link
          :class="{
            'inline-block px-1 py-3 border-b-2': true,
            'text-gray-500 dark:text-gray-400 text-opacity-75 hover:text-opacity-100 border-transparent hover:border-separator hover:border-gray-200 dark:hover:border-gray-700':
              tab.handle !== activeTab,
            'text-blue-600 dark:text-blue-400 border-blue-600 dark:border-blue-400 text-opacity-100':
              tab.handle === activeTab,
          }"
          :to="'/search?q=' + $route.query.q + '&tab=' + tab.handle"
        >
          {{ tab.name }}
        </c-link>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      activeTab: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        tabs: [
          {
            name: 'Plugins',
            handle: 'plugins',
          },
          // TODO: Enable developer search
          // {
          //   name: 'Developers',
          //   handle: 'developers',
          // },
        ],
      };
    },
  };
</script>
